import { serializedErrorToWebDataError, WebData, webDataLoading, webDataNotAsked, webDataSuccess } from "@lvt/web-data";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Client, fetchClients } from "@/api/clients";
import { fetchStreamMetadata } from "@/api/streamMetadata";
import { RootState } from "@/store";


export interface ClientsState {
    clients: WebData<Array<Client>>;
    selectedClient: Client | null;
    selectedClientId: number | null;
}

const initialState: ClientsState = {
    clients: webDataNotAsked(),
    selectedClient: null,
    selectedClientId: null,
};

export const clientsSlice = createSlice({
    name: "clients",
    initialState,
    reducers: {
        selectClient: (state, action: PayloadAction<Client>) => {
            state.selectedClientId = action.payload.id;
        },
        setSelectedClient(state, action: PayloadAction<Client | null>) {
            state.selectedClient = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchClients.pending, (state) => {
                state.clients = webDataLoading();
            })
            .addCase(fetchClients.fulfilled, (state, action) => {
                state.clients = webDataSuccess(action.payload);
            })
            .addCase(fetchClients.rejected, (state, action) => {
                state.clients = serializedErrorToWebDataError(action.error);
            })
            .addCase(fetchStreamMetadata.fulfilled, (state, action) => {
                state.selectedClientId = action.payload.clientId;
            });
    },
});

export const { selectClient, setSelectedClient } = clientsSlice.actions;
export const clientsReducer = clientsSlice.reducer;
export const clientsSelectors = {
    getClients: (state: RootState) => {
        return state.clients.clients;
    },
    getSelectedClientId: (state: RootState) => {
        return state.clients.selectedClientId;
    },
};
